import { createAction, props } from '@ngrx/store';
import { FedexFacility } from '../models/fedex-facility.model';

export const loadFedexFacilities = createAction(
  '[FedEx Facility] Load FedEx Facilities',
  props<{ organizationId: string }>()
);

export const loadFedexFacilitiesSuccess = createAction(
  '[FedEx Facility] Load FedEx Facilities Success',
  props<{ facilities: FedexFacility[] }>()
);

export const loadFedexFacilitiesFailure = createAction(
  '[FedEx Facility] Load FedEx Facilities Failure',
  props<{ error: any }>()
);

// Add FedEx Facility
export const addFedexFacility = createAction(
  '[FedEx Facility] Add FedEx Facility',
  props<{ organizationId: string, facility: FedexFacility }>()
);

export const addFedexFacilitySuccess = createAction(
  '[FedEx Facility] Add FedEx Facility Success',
  props<{ facility: FedexFacility }>()
);

// Update FedEx Facility
export const updateFedexFacility = createAction(
  '[FedEx Facility] Update FedEx Facility',
  props<{ organizationId: string, facilityId: number, facility: Partial<FedexFacility> }>()
);

export const updateFedexFacilitySuccess = createAction(
  '[FedEx Facility] Update FedEx Facility Success',
  props<{ facility: FedexFacility }>()
);

// Delete FedEx Facility
export const deleteFedexFacility = createAction(
  '[FedEx Facility] Delete FedEx Facility',
  props<{ organizationId: string, facilityId: number }>()
);

export const deleteFedexFacilitySuccess = createAction(
  '[FedEx Facility] Delete FedEx Facility Success',
  props<{ facilityId: number }>()
);
